import type { InjectionKey, Ref } from 'vue';

/**
 * VAアプリ用: Zoom電話ウィジェットの表示/非表示状態の provide/inject キー。
 */
export const ZOOM_PHONE_WIDGET_VISIBLE_KEY: InjectionKey<Ref<boolean>>
  = Symbol('ZOOM_PHONE_WIDGET_VISIBLE');
